import { render } from "./OrderProcessing.vue?vue&type=template&id=58d3862a"
import script from "./OrderProcessing.vue?vue&type=script&lang=js"
export * from "./OrderProcessing.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__